<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a">About the author</h2>
<p class="para">David Squire has a lifetime’s experience with plants, both cultivated and native types. Throughout his gardening and journalistic careers, David has written more than 80 books on plants and gardening, including 14 books in this Specialist Guide series. He also has a wide interest in the uses of native plants, whether for eating and survival, or for their historical roles in medicine, folklore and customs.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?2a8ed77a